export enum AccountTypeIdEnum {
  ContributionAccount = 1,
  VariableBenefitAccount = 3,
  AnnuityPensionAccount = 4,
  VPLAPensionAccount = 5,
  MemberClearingAccount = 6,
  EmployerClearingAccount = 7,
  SPPRemittances = 8,
  SPPSettlement = 9,
  SPPAccountAdjustments = 10,
  SPPTransfers = 11,
  TransferInAccount = 16
}
